// extracted by mini-css-extract-plugin
export default {"inlineCaption":"InlineCaption_inlineCaption__PyZOZ"};